"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.certificateMapper = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _CertificateProfile = _interopRequireWildcard(require("./CertificateProfile"));

var _CertificatePDF = _interopRequireDefault(require("./CertificatePDF"));

var _ = require("..");

var _excluded = ["product", "productionUnit", "labels", "key", "renderKey", "isAttest", "pdf"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {// maxWidth: 345,
    },
    card: {
      // maxWidth: 345,
      position: 'relative',
      margin: theme.spacing(3),
      maxWidth: 600
    },
    pdf: {},
    media: {
      paddingTop: '50%'
    },
    label: {
      backgroundColor: theme.palette.primary[500]
    }
  };
});

var CertificateCard = function CertificateCard(_ref) {
  var extraClasses = _ref.classes,
      className = _ref.className,
      onClick = _ref.onClick,
      onClickPDF = _ref.onClickPDF,
      children = _ref.children,
      noMedia = _ref.noMedia,
      coverSrc = _ref.coverSrc,
      coverTitle = _ref.coverTitle,
      labels = _ref.labels,
      title = _ref.title,
      subTitle = _ref.subTitle,
      pdfSrc = _ref.pdfSrc,
      profileProps = _ref.profileProps,
      pdfWidth = _ref.pdfWidth;
  var classes = useStyles({
    classes: extraClasses
  });

  var cardContent = /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, !noMedia ? /*#__PURE__*/_react["default"].createElement(_core.CardMedia, {
    className: classes.media,
    image: coverSrc,
    title: coverTitle
  }) : '', /*#__PURE__*/_react["default"].createElement(_core.CardContent, null, labels && labels.length > 0 ? /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, null, labels.map(function (_ref2) {
    var title = _ref2.title,
        label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      title: title
    }, /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
      className: classes.label
    }, label));
  })) : '', /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    gutterBottom: true,
    variant: "h5",
    component: "h2"
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    gutterBottom: true,
    variant: "body2"
  }, subTitle), children), !noMedia && pdfSrc ? /*#__PURE__*/_react["default"].createElement(_CertificatePDF["default"], {
    src: pdfSrc,
    width: pdfWidth,
    classes: {
      root: classes.pdf
    },
    onClick: onClickPDF
  }) : '', /*#__PURE__*/_react["default"].createElement(_CertificateProfile["default"], profileProps));

  if (onClick) {
    return /*#__PURE__*/_react["default"].createElement(_core.Card, {
      className: (0, _classnames["default"])(className, classes.card)
    }, /*#__PURE__*/_react["default"].createElement(_core.CardActionArea, {
      onClick: onClick
    }, cardContent));
  }

  return /*#__PURE__*/_react["default"].createElement(_core.Card, {
    className: classes.card
  }, cardContent);
};

var certificateMapper = function certificateMapper(_ref3, unit, manufacturer, tLabels) {
  var product = _ref3.product,
      productionUnit = _ref3.productionUnit,
      labels = _ref3.labels,
      key = _ref3.key,
      renderKey = _ref3.renderKey,
      isAttest = _ref3.isAttest,
      pdf = _ref3.pdf,
      other = _objectWithoutProperties(_ref3, _excluded);

  var _manufacturer = manufacturer || productionUnit && productionUnit.manufacturer;

  var _unit = unit || productionUnit;

  var cover = product && product.cover;
  return {
    coverSrc: cover && cover.src,
    coverTitle: _manufacturer && _manufacturer.title,
    pdfSrc: pdf && pdf.src,
    title: renderKey,
    subTitle: isAttest ? /*#__PURE__*/_react["default"].createElement(_core.Box, {
      display: "flex"
    }, /*#__PURE__*/_react["default"].createElement(_.Label, {
      warning: true
    }, tLabels.attest), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      style: {
        marginLeft: 8
      }
    }, product && product.renderCodes)) : product && product.renderCodes,
    profileProps: (0, _CertificateProfile.certificateMapper)(_objectSpread({
      _unit: _unit
    }, other), _unit, _manufacturer, true, tLabels)
  };
};

exports.certificateMapper = certificateMapper;
CertificateCard.propTypes = {
  className: _propTypes["default"].string,
  certificate: _propTypes["default"].object.isRequired,
  noMedia: _propTypes["default"].bool.isRequired,
  pdfWidth: _propTypes["default"].number
};
CertificateCard.defaultProps = {
  className: '',
  noMedia: false
};
var _default = CertificateCard;
exports["default"] = _default;